import React, { useState, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import { performAccountTransaction } from '../../../api'; // Adjust the path as necessary
import MyButton from '../../basic/MyButton'; // Adjust path if necessary
import MyTextInput from '../../basic/MyTextInput'; // Adjust path if necessary
import { useFamily } from '../../../context/FamilyContext';
import { currencies } from '../../basic/currencies';


Modal.setAppElement('#root'); // Properly set the app element to avoid accessibility issues

function TransactionModal({ isOpen, onClose, childId, accountId, accountName, balance, transactionType, onTransactionSuccess }) {
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { currencyCode } = useFamily();

    useEffect(() => {
        if (isOpen) {
            setAmount('');
            setReason('');
            setError('');
        }
    }, [isOpen]);

    const getCurrencySymbol = useCallback(() => {
        const currency = currencies.find(c => c.code === currencyCode);
        return currency ? currency.symbol : '$'; // Default to '$' if not found
    }, [currencyCode]);

    const handleAmountChange = (e) => {
        const value = e.target.value;
        if (value === '' || (parseFloat(value) >= 0 && !isNaN(parseFloat(value)))) {
            setAmount(value);
        }
    };

    const handleReasonChange = (e) => {
        setReason(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        const numericAmount = parseFloat(amount);

        if (transactionType === 'withdrawal' && numericAmount > balance) {
            setError('Insufficient funds for withdrawal');
            setLoading(false);
            return;
        }

        try {
            const response = await performAccountTransaction(childId, accountId, numericAmount, reason, transactionType);
            onTransactionSuccess(`Successfully ${transactionType === 'deposit' ? 'deposited' : 'withdrew'} ${amount}`);
            onClose();
        } catch (error) {
            console.error('Transaction failed:', error);
            setError('Failed to process transaction. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: {
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                },
                content: {
                    top: '50%',
                    left: '50%',
                    right: 'auto',
                    bottom: 'auto',
                    marginRight: '-50%',
                    transform: 'translate(-50%, -50%)'
                }
            }}
        >
            <h2>{transactionType === 'deposit' ? 'Deposit to' : 'Withdraw from'} {accountName}</h2>
            <p>Current Balance: {getCurrencySymbol()}{balance}</p>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
                <MyTextInput
                    label="Amount"
                    name="amount"
                    value={amount}
                    onChange={handleAmountChange}
                    type="number"
                    step="1"
                    min="0"
                    required
                />
                <MyTextInput
                    label="Reason (optional)"
                    name="reason"
                    value={reason}
                    onChange={handleReasonChange}
                />
                <MyButton 
                    text={loading ? 'Processing...' : `Confirm ${transactionType}`} 
                    onClick={handleSubmit} 
                    disabled={loading || amount === '' || parseFloat(amount) <= 0}
                />
                <MyButton 
                    text="Cancel" 
                    onClick={onClose} 
                    backgroundColor="white"
                    color="#dc3545"
                    hoverBackgroundColor="#f8f8f8"
                    hoverColor="#c82333"
                />
            </form>
        </Modal>
    );
}

export default TransactionModal;